import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from '@/core/store/hooks'
import { userSelector } from '@/modules/Auth/store/AuthSelector'
import { getUserThunk, onLogout } from '@/modules/Auth/store/AuthSlice'
import { cn } from '@bem-react/classname'

import useElementSize from '@/hooks/useElementSize'
import { useHandleServerError } from '@/hooks/useHandleServerError'

import { Button } from '@/components/UI/Button'
import Icon from '@/components/UI/Icon'
import { Logo } from '@/components/UI/Logo'

import { User } from '../User'
import './Header.scss'

interface IHeaderProps {
  className?: string
  isHome?: boolean
}

const cnHeader = cn('Header')

export const Header: FC<IHeaderProps> = ({ className, isHome }) => {
  const { width } = useElementSize()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { handleServerError } = useHandleServerError()
  const { t } = useTranslation()

  const user = useAppSelector(userSelector)

  const getUser = async () => {
    try {
      await dispatch(getUserThunk()).unwrap()
    } catch (error) {
      handleServerError(error)
    }
  }

  useEffect(() => {
    const token = localStorage.getItem('token')
    if (token) getUser()
  }, [])

  const logout = () => {
    localStorage.clear()
    navigate('/')
    dispatch(onLogout())
  }

  const login = () => {
    navigate('/login')
  }

  return (
    <header className={cnHeader({ home: isHome }, [className])}>
      <div className={cnHeader('content', { home: isHome })}>
        <Logo to={isHome ? '/' : '/c'} className={cnHeader('logo')} />
        {user && <User width={width} className={cnHeader('user')} />}

        <div className={cnHeader('right')}>
          {isHome ? (
            <>
              {!user ? (
                <Button
                  color='light'
                  size='lg'
                  iconPosition='left'
                  onClick={login}
                  icon={!!width && width <= 768}
                >
                  <Icon name='logout' />
                  {!!width && width > 768 && t('header-log-in')}
                </Button>
              ) : (
                <Button
                  color='light'
                  size='lg'
                  iconPosition='left'
                  onClick={logout}
                  icon={!!width && width <= 768}
                >
                  <Icon name='logout' />
                  {!!width && width > 768 && t('header-log-out')}
                </Button>
              )}
            </>
          ) : (
            <>
              <Button color='light' size='lg' icon={!!width && width <= 768}>
                <Icon name='notice' />
              </Button>
              <Button
                color='light'
                size='lg'
                iconPosition='left'
                onClick={logout}
                icon={!!width && width <= 768}
              >
                <Icon name='logout' />
                {!!width && width > 768 && t('header-log-out')}
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  )
}
